const asyncLoader = ({store, route, rooter}) => {
  if (!route) {
    return Promise.resolve(false)
  }
  return store.dispatch('somnambulistui/init')
    .then(() => store.dispatch('user/init'))
    .then(() => {
      return Promise.all(
        [
          store.dispatch('filestore/getFileURLBulk', { preset: '__original', files: store.state.somnambulistui.clubs.filter(club => club && club.image && club.image.filepath).map(club => club.image) }),
          ...Object.values(store.state.somnambulistui.clubs).reduce((acc, club) => {
            acc.push(store.dispatch('node/lookupItem', { path: club.seo.path }))
            acc.push(store.dispatch('node/itemAccess', { id: club.id }))
            return acc
          }, [])
        ]
      )
    })
    .catch(err => {
      console.error(`Somnambulist UI AsyncData Error: ${err.message}`)
    })
}

const pageMixin = {
  computed: {
    clubs() {
      return Object.values(this.$store.state.somnambulistui.clubs)
    }
  }
}

export { pageMixin, asyncLoader }
